import { border, lodestarColors, motion, ursaColors } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";
import { shadowMenu } from "../../../constants/colors";
export var menuTheme = themed({
  borderRadius: {
    "lodestar-light": border.radius10,
    "ursa-light": border.radius20
  },
  fontSize: {
    "lodestar-light": "inherit",
    "ursa-light": "14px"
  },
  optionHeight: {
    // Ursa uses 38px for all menu items.
    normal: {
      "lodestar-light": 40,
      "ursa-light": 38
    },
    compact: {
      "lodestar-light": 32,
      "ursa-light": 38
    }
  },
  separatorHeight: {
    "lodestar-light": 24,
    "ursa-light": 24
  },
  fontColor: {
    rest: {
      "lodestar-light": lodestarColors.neutralDark30,
      "ursa-light": ursaColors.neutral800
    },
    focus: {
      "lodestar-light": lodestarColors.neutralDark40,
      "ursa-light": ursaColors.neutral800
    },
    hover: {
      "lodestar-light": lodestarColors.neutralDark40,
      "ursa-light": ursaColors.neutral800
    },
    disabled: {
      "lodestar-light": lodestarColors.neutralDark10,
      "ursa-light": ursaColors.neutral400
    }
  },
  boxShadow: {
    "lodestar-light": "0 2px 12px 0 ".concat(shadowMenu),
    // TODO use the official elevation color tokens for this at some point.
    "ursa-light": "0px 2px 4px rgba(57, 61, 76, 0.16), 0px 6px 12px rgba(65, 80, 139, 0.12)"
  },
  backgroundColor: {
    focus: {
      "lodestar-light": lodestarColors.neutralLight20,
      "ursa-light": ursaColors.neutral50
    },
    pressed: {
      "lodestar-light": lodestarColors.neutralLight20,
      "ursa-light": ursaColors.neutral75
    },
    hover: {
      "lodestar-light": lodestarColors.neutralLight20,
      "ursa-light": ursaColors.neutral50
    },
    rest: {
      "ursa-light": ursaColors.neutral00,
      "lodestar-light": lodestarColors.neutralLight40
    }
  },
  hasContentLeftPadding: {
    "lodestar-light": "28px",
    "ursa-light": "32px"
  },
  motion: {
    itemBackground: {
      "lodestar-light": "",
      "ursa-light": "background-color ".concat(motion.animation.default)
    },
    animation: {
      "lodestar-light": "",
      "ursa-light": motion.animation.default
    }
  }
});
//# sourceMappingURL=menuTheme.js.map